import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { Pagination } from '../../components/Pagination';
import { Table } from '../../components/Table';
import { useQueryString } from '../../hooks';
import { MomentFormat, utcToLocalFormat } from '../../plugins/moment';
import { fetcher } from '../../plugins/react-query';
import { Notice, Paginated } from '../../types';
import { AdminH1 } from '../components/AdminH1';

export const NoticeList = () => {
  const queryString = useQueryString();

  const { data: notices } = useQuery<Paginated<Notice>>(
    `/admin/notices${queryString}`,
    fetcher,
    { keepPreviousData: true },
  );

  if (!notices) {
    return <></>;
  }
  return (
    <>
      <div className="flex justify-between">
        <AdminH1>Notices</AdminH1>
        <Button
          text="Add"
          to={`/admin/notices/add`}
          className="h-8 font-normal text-indigo-600 hover:text-indigo-900"
        />
      </div>

      <Card>
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.Th>created at</Table.Th>
              <Table.Th>title</Table.Th>
              <Table.Th>hide</Table.Th>
              <Table.Th></Table.Th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {notices.items.map((notice) => (
              <Table.Row key={notice.id}>
                <Table.Td>
                  {utcToLocalFormat(notice.createdAt, MomentFormat.LLL)}
                </Table.Td>
                <Table.Td>{notice.title}</Table.Td>
                <Table.Td>{notice.isHide ? '숨김' : '-'}</Table.Td>
                <Table.Td className="text-right">
                  <Link
                    className="font-normal text-indigo-600 hover:text-indigo-900"
                    to={`/admin/notices/${notice.id}`}
                  >
                    Details
                  </Link>
                </Table.Td>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        <Pagination>
          <Pagination.Label
            count={notices?.items.length}
            total={notices.total}
          />
          <Pagination.Nav basePath="/admin/notices" total={notices.total} />
        </Pagination>
      </Card>
    </>
  );
};
